import { Component, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-asmt-footer',
  templateUrl: './assessment-footer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AssessmentFooterComponent {
  env: any = environment;
}
